import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../components/Login.vue'
import Gifts from '../components/Gifts.vue'
import Success from '../components/Success.vue'
import Admin from '../components/Admin.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/gifts',
    name: 'Gifts',
    component: Gifts
  },
  {
    path: '/success',
    name: 'Success',
    component: Success
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router